(ns manage.ad-variant.creation.template.hooks
  (:require [manage.ad-variant.data :as d]
            [manage.adset.hooks :as ah]
            [uix.core :refer [defhook]]))

(defhook use-select-ad-formats? []
  (let [adset (ah/use-adset)]
    (> (count (d/dynamic-creation-ad-types adset)) 1)))
